import { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { filesRoute } from "../api/routes";
import { assets } from "../assets/assets";
import config from "../config";

const ProfilePicURL = (userData = null) => {
    const [authContext, setAuthContext] = useContext(AuthContext);
    if (userData === null) {
        userData = authContext.userData;
    }
    if(userData.isTwitchLogin || userData.isTwitch || userData.authStrategy == 'twitch' || userData.profilePic.indexOf('https://') !=-1) return  userData.profilePic;
    if(userData.profilePic === '') return assets.BlankUser;

    // Non-local environments serve via CloudFront (same as feature assets)
    if (process.env.REACT_APP_NODE_ENV !== 'local') {
        return `${config.cloudfrontBaseUrl}/profile-pics/${userData.profilePic}`;
    }

    return filesRoute + '/profile-pics/' + userData.profilePic;

}
export { ProfilePicURL }